angular.module('gym.contacts').factory('MembershipService', ["$q", "Memberships", "MembershipPlanService", function($q, Memberships, MembershipPlanService) {
  var MembershipService, parseErrors, secondStepFields;
  secondStepFields = ['charge_interval_number', 'cost_repeat', 'cost_upfront', 'recurring_payments_start_on', 'tax_status', 'upfront_payment_on', 'failure_fee_lead_days', 'failure_fee_schedule_strategy', 'failure_fee_invoice_email_status', 'failure_fee_auto_reschedule_status'];
  parseErrors = function(errors, step) {
    if (step === 1) {
      errors = _.omit(errors, secondStepFields);
    }
    return _.omit(errors, 'contact', 'membership_plan');
  };
  MembershipService = {
    validate: function(membership, step) {
      var deferred, params, ref;
      deferred = $q.defer();
      if (step === 1 && MembershipPlanService.hasInvalidTypeLimit(membership.per_event_type_limits)) {
        deferred.reject({
          per_event_type_limits: ['Is invalid']
        });
        return deferred.promise;
      }
      params = {
        membership: angular.copy(membership),
        withoutNamespace: true
      };
      params.membership.membership_plan_id = (ref = membership.membership_plan) != null ? ref.id : void 0;
      Memberships.doPOST(params, 'validate').then(function() {
        return deferred.resolve({});
      }, function(response) {
        var errors;
        errors = parseErrors(response.data.errors, step);
        if (_.isEmpty(errors)) {
          return deferred.resolve({});
        } else {
          return deferred.reject(errors);
        }
      });
      return deferred.promise;
    }
  };
  return MembershipService;
}]);
